import React from "react";
import HeaderAd from "../../utils/HeaderAd";
import { Link } from "gatsby";
export default function HowTo() {
  return (
    <section className="how-to my-8 border-t pt-6">
      <div className="container mx-auto">
        <div className="flex flex-wrap">
          <div className="w-full md:w-2/3  p-4">
            <h3 className="font-semibold text-2xl mb-3">Why receipt maker?</h3>
            <p className="mb-1">
              If you have any type of business that requires you to provide a
              receipt, Receipt Maker is the easiest way to make receipts for
              customers. Generate your receipts for 100% FREE and no attribution
              requires.
            </p>
            <div className="features mb-6">
              <p className="font-bold text-lg mb-1">Features</p>
              <ul className="list-decimal list-inside">
                <li>100% Free</li>
                <li>Live updates</li>
                <li>Offline support</li>
                <li>Fully clientside so we dont store any data</li>
              </ul>
            </div>
            <h3 className="font-semibold text-2xl mb-3">How to use ?</h3>
            <p className="mb-6">
              Its very simple to use, modify your business name, address,
              currency, and font style. You can add one or more tax and purchase
              items as your needs. You will see the updates in real-time. once
              done just click on the download button. <br />
              If you want a detailed step by step guide or a video please visit{" "}
              <Link className="text-purple-600 hover:underline" to="/how-to/">
                this link
              </Link>{" "}
              or click on how to link from the navbar.
            </p>

            <h3 className="font-semibold text-2xl mb-3">Browser support?</h3>
            <p className="mb-6">
              This site supports most of the modern browsers but I would
              recommend using Google Chrome, Microsoft Edge, or firefox. If you
              are facing any issues using the site please send me an{" "}
              <a
                className="text-purple-600 hover:underline"
                href="mailto:dipankarmaikap77@gmail.com?subject=Browser issues for receipt maker website&body"
              >
                email
              </a>
              .
            </p>
            <h3 className="font-semibold text-2xl mb-3">Feature Request?</h3>
            <p className="mb-6">
              If you think this site missing or need a feature feel free to{" "}
              <a
                className="text-purple-600 hover:underline"
                href="mailto:dipankarmaikap77@gmail.com?subject=Feature request&body"
              >
                mail me
              </a>
              . If you need a fully custom receipt maker for your business, I'm
              also available for freelance work.
            </p>
          </div>
          <div className="w-full md:w-1/3 p-2">
            <HeaderAd />
          </div>
        </div>
      </div>
    </section>
  );
}
